import React, { useState } from 'react';
import VideoPlayer from '../components/VideoPlayer';
import LoginPopup from '../components/Login'; // varsa

const Home = () => {
  const [showLoginPopup, setShowLoginPopup] = useState(false);

  const handleOpenLogin = () => {
    setShowLoginPopup(true);
  };

  const handleCloseLogin = () => {
    setShowLoginPopup(false);
  };

  return (
    <>
      <VideoPlayer openLoginPopup={handleOpenLogin} />
      {showLoginPopup && <LoginPopup onClose={handleCloseLogin} />}
    </>
  );
};

export default Home;
